import { render, staticRenderFns } from "./Validation.vue?vue&type=template&id=380f0f16"
import script from "./Validation.vue?vue&type=script&lang=js"
export * from "./Validation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports